"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Row = _interopRequireDefault(require("./Body/Row"));

var _Footer = _interopRequireDefault(require("./Footer/Footer"));

var _ScrollableColumns = _interopRequireDefault(require("./Header/ScrollableColumns"));

var _Pagination = _interopRequireDefault(require("../Pagination"));

var _types = require("./utils/types");

require("./Table.css");

var _utils = require("./utils/utils");

var _HeaderMini = _interopRequireDefault(require("./Header/HeaderMini"));

var _NoDataCell = _interopRequireDefault(require("./NoDataCell"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var TableMini = function TableMini(props) {
  var table = props.table,
      columns = props.columns,
      data = props.data,
      footer = props.footer,
      mini = props.mini,
      paging = props.paging,
      sorting = props.sorting,
      scrollable = props.scrollable,
      tableBodyStyle = props.tableBodyStyle,
      expandedRows = props.expandedRows,
      pagingTotal = props.pagingTotal,
      noDataText = props.noDataText,
      headerControls = props.headerControls,
      classNameTable = props.classNameTable,
      classNameTableWrapper = props.classNameTableWrapper,
      onRow = props.onRow,
      onMouseDown = props.onMouseDown,
      changeSorting = props.changeSorting,
      expandOnClick = props.expandOnClick,
      changePagination = props.changePagination;
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: table,
    role: "presentation",
    className: classNameTableWrapper,
    onMouseDown: onMouseDown,
    onPointerDown: onMouseDown
  }, /*#__PURE__*/_react.default.createElement(_HeaderMini.default, {
    columns: columns,
    sorting: sorting,
    changeSorting: changeSorting,
    headerControls: headerControls
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "Table-content",
    style: tableBodyStyle
  }, /*#__PURE__*/_react.default.createElement("table", {
    className: classNameTable
  }, /*#__PURE__*/_react.default.createElement(_ScrollableColumns.default, {
    scrollable: scrollable,
    columns: columns,
    mini: mini
  }), /*#__PURE__*/_react.default.createElement("tbody", null, data.length ? data.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_Row.default, {
      data: item,
      index: index,
      columns: columns,
      scrollable: scrollable,
      expandedRows: expandedRows,
      onRow: (0, _utils.onRowFunction)(onRow),
      expandOnClick: expandOnClick
    });
  }) : /*#__PURE__*/_react.default.createElement(_NoDataCell.default, {
    colSpan: columns.length,
    noDataText: noDataText
  })), !scrollable && footer && /*#__PURE__*/_react.default.createElement(_Footer.default, {
    columns: columns,
    footer: footer
  }))), pagingTotal > data.length && /*#__PURE__*/_react.default.createElement(_Pagination.default, _extends({}, paging, {
    total: pagingTotal,
    onChange: changePagination
  })));
};

TableMini.propTypes = {
  table: _propTypes.default.shape({
    current: _propTypes.default.node
  }),
  columns: _propTypes.default.arrayOf(_propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.shape, _propTypes.default.bool, _propTypes.default.func])))),
  data: _propTypes.default.arrayOf(_propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.shape, _propTypes.default.func])))),
  footer: _propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.func]))),
  mini: _propTypes.default.bool,
  paging: _types.pagingState,
  sorting: _types.sortState,
  scrollable: _propTypes.default.bool,
  tableBodyStyle: _propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.string)),
  expandedRows: _propTypes.default.arrayOf(_propTypes.default.string),
  pagingTotal: _propTypes.default.number.isRequired,
  noDataText: _propTypes.default.string,
  headerControls: _propTypes.default.shape({
    selectControlsLabel: _propTypes.default.shape({
      selectAll: _propTypes.default.string,
      reset: _propTypes.default.string
    }),
    sortByLabel: _propTypes.default.string
  }).isRequired,
  classNameTable: _propTypes.default.string,
  classNameTableWrapper: _propTypes.default.string,
  onRow: _propTypes.default.func,
  onMouseDown: _propTypes.default.func,
  changeSorting: _propTypes.default.func,
  expandOnClick: _propTypes.default.func,
  changePagination: _propTypes.default.func
};
TableMini.defaultProps = {
  table: {
    current: null
  },
  columns: [],
  data: [],
  footer: null,
  mini: true,
  paging: null,
  sorting: {},
  scrollable: false,
  tableBodyStyle: {},
  expandedRows: [],
  noDataText: 'No data',
  classNameTable: '',
  classNameTableWrapper: '',
  onRow: null,
  onMouseDown: function onMouseDown() {},
  changeSorting: function changeSorting() {},
  expandOnClick: function expandOnClick() {},
  changePagination: function changePagination() {}
};
var _default = TableMini;
exports.default = _default;